'use strict';

class ResetPassword {

    constructor() {
        this.stepone = document.getElementById('stepone');
        this.steptwo = document.getElementById('steptwo');
        this.stepthree = document.getElementById('stepthree');
        this.submitOrganisationButton = document.getElementById('submit-organisationbutton');
        this.submitEmailButton = document.getElementById('submit-emailbutton');
        this.addEventListeners();
    }

    addValidationError(el, mess) {
        const div = document.createElement("div");
        div.className = "validation-error";
        div.innerHTML += '<p style="color:red">' + mess + '</p>';
        el.parentNode.append(div);
    }

    clearValidationErrors() {
        const elements = document.querySelectorAll('.validation-error');
        var len = elements.length;
        for (var i = 0; i < len; i++) {
            elements[i].parentNode.removeChild(elements[i]);
        }
    }

    addEventListeners() {
        if (typeof (this.submitEmailButton) != 'undefined' && this.submitEmailButton != null) {
            this.submitEmailButton.addEventListener('click',
                async (e) => {
                    this.clearValidationErrors();
                    e.preventDefault();
                    e.stopPropagation();

                    if (!document.getElementById('email').checkValidity()) {
                        return;
                    }
                    e.preventDefault();
                    await this.finishStepOne();
                });
        }
        if (typeof (this.submitOrganisationButton) != 'undefined' && this.submitOrganisationButton != null) {
            this.submitOrganisationButton.addEventListener('click',
                async (e) => {
                    this.clearValidationErrors();
                    e.preventDefault();
                    e.stopPropagation();

                    if (!document.getElementById('organisation').checkValidity()) {
                        return;
                    }
                    e.preventDefault();
                    await this.finishStepTwo();
                });
        }
    }

    async finishStepOne() {
        var self = this;
        try {
            
            self.submitEmailButton.setAttribute("disabled", true);
            const email = document.getElementById('email').value;
            const body = { email };
            
            const request = await fetch('/password/stepone/',
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify(body)
                })
            const json = await request.json();

            self.submitEmailButton.removeAttribute("disabled");
            //light up step 2
            if (json.stepFinished === 1) {
                self.stepone.classList.add('hidden');
                self.steptwo.classList.remove('hidden');
            }
            //wizard finished
            else if (json.stepFinished === 2) {
                self.stepone.classList.add('hidden');
                self.steptwo.classList.add('hidden');
                self.stepthree.classList.remove('hidden');
            } else if (json.isError) {
                self.addValidationError(self.submitEmailButton, json.message);
            }
        }
        catch (ex) {
            console.error(ex);
        }
    }
    async finishStepTwo() {
        var self = this;
        try {
            
        self.submitOrganisationButton.setAttribute("disabled", true);
        const email = document.getElementById('email').value;
        const organisation = document.getElementById('organisation').value;
        const request = await fetch('/password/steptwo/',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({
                    email,organisation
                })
            })

            const json = request.json();
            self.submitOrganisationButton.removeAttribute("disabled");
            //light up step 3
            if (json.stepFinished === 2) {
                self.stepone.classList.add('hidden');
                self.steptwo.classList.add('hidden');
                self.stepthree.classList.remove('hidden');
            } else if (json.isError) {
                self.addValidationError(self.submitOrganisationButton, json.message);
            }

        } catch (ex) {
            console.error(ex);
        }
    }

}


document.addEventListener("DOMContentLoaded", () => new ResetPassword());